import { render, staticRenderFns } from "./ListaSpecifiche.vue?vue&type=template&id=1cfe916b&scoped=true&"
import script from "./ListaSpecifiche.vue?vue&type=script&lang=js&"
export * from "./ListaSpecifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe916b",
  null
  
)

export default component.exports